import { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import ScaleBar from '@arcgis/core/widgets/ScaleBar';

function GHScaleBar(props) {
  const [scaleBar, setScaleBar] = useState(null);
  useEffect(() => {
    const scaleBarWidget = new ScaleBar({
      id: 'scaleBar',
      unit: 'non-metric',
      view: props.view,
    });

    setScaleBar(scaleBarWidget);
    props.view.ui.add(scaleBarWidget, 'manual');

    return function cleanup() {
      props.view.ui.remove(scaleBar);
    };
  }, [props.view]);
  return null;
}

GHScaleBar.propTypes = {
  view: PropTypes.object
}

export default GHScaleBar